import React, { useEffect, useRef, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { Option } from "./Option";

interface Item {
  label: React.ReactNode;
  value: string;
}
export interface Options {
  label: React.ReactNode;
  items: Item[];
}

export interface SearchBoxProps {
  placeholder?: string;
  className?: string;
  style?: React.CSSProperties;
  onSearch?: (event: HTMLInputElement) => void;
  Icon?: React.ReactNode;
  onClick?: () => void;
  options?: Options[] | undefined;
  onSelect?: (event: string) => void;
}

export const SearchBox: React.FC<SearchBoxProps> = ({
  placeholder,
  className,
  style,
  onSearch,
  Icon,
  onClick,
  onSelect,
  options,
}) => {
  const [trigger, setTrigger] = useState<boolean>(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const dropDownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onMouseClick = (e: MouseEvent): void => {
      if (
        inputRef.current &&
        !inputRef.current.contains(e?.target as Node) &&
        dropDownRef.current &&
        !dropDownRef.current.contains(e?.target as Node)
      ) {
        setTrigger(false);
      }
    };

    document.addEventListener("click", onMouseClick);

    return () => {
      document.removeEventListener("click", onMouseClick);
    };
  }, []);

  return (
    <div
      className={className + "flex w-full relative bg-white rounded-md"}
      style={style}
    >
      <div
        className="flex w-full justify-center items-center shadow rounded-md"
        ref={inputRef}
      >
        <input
          className="flex-1 outline-none border-none px-2 py-1"
          onChange={(e) => {
            onSearch?.(e.currentTarget);
          }}
          placeholder={placeholder}
          onClick={() => setTrigger(true)}
        />
        <div
          className="cursor-pointer px-5 p-3 h-full text-white bg-primary rounded-r-md flex justify-center items-center"
          aria-label="Search"
          title="Search"
          onClick={() => {
            setTrigger(false);
            onClick?.();
          }}
        >
          {(Icon && Icon) || <FaSearch />}
        </div>
      </div>
      {trigger && options && options.length !== 0 && (
        <div
          className="absolute w-full max-h-[250px] overflow-y-scroll rounded-b-md overflow-x-hidden mt-1 bg-white border border-gray-200 top-full transition-all ease-in-out duration-200 text-primary scroll-bar"
          ref={dropDownRef}
        >
          {options.map(
            (option, index) =>
              option && (
                <Option
                  key={index}
                  label={option.label}
                  items={option.items}
                  onClick={(event) => {
                    setTrigger(false);
                    onSelect?.(event);
                  }}
                />
              )
          )}
        </div>
      )}
    </div>
  );
};
export default SearchBox;
